import { IdentityTypeDecorator } from '../decorators/identity-type.decorator';
import { Expose, Transform } from '@nts/std/serialization';
import { DateDecorator } from './decorators/date.decorator';
import { ModelTypeNameDecorator } from './decorators/model-type-name.decorator';
import { NumberDecorator } from './decorators/number.decorator';
import { StringDecorator } from './decorators/string.decorator';
import { SnapShotFrameIdentity } from './snap-shot-frame-identity';
import { DateTimeOffset } from '@nts/std/types';
import type { SnapShotFrameIdentityInterface, SnapShotFrameInterface } from '@nts/std/interfaces';
import { OCCAuditDeactivableModel } from './occ-audit-deactivable-model';


@IdentityTypeDecorator(SnapShotFrameIdentity)
@ModelTypeNameDecorator('SnapShotFrame')
export class SnapShotFrame extends OCCAuditDeactivableModel<SnapShotFrameIdentityInterface> implements SnapShotFrameInterface<SnapShotFrameIdentityInterface> {

    private _identity: number;

    @Expose()
    @NumberDecorator({ displayNameKey: 'SnapShotFrame_Identity' })
    get identity(): number {
        return this.getValueForIdentityValue<number>(() => this._identity, 'identity');
    }
    set identity(value: number) {
        this.setValueForIdentityValue<number>(() => { this._identity = value; }, value, 'identity');
    }

    private _extendedUpdateUser: string;

    @Expose()
    @StringDecorator({ displayNameKey: 'std_OCCAuditDeactivableModel_UpdateUser' })
    override get updateUser(): string {
        return this.getValue<string>(() => this._extendedUpdateUser, 'updateUser');
    }
    override set updateUser(value: string) {
        this.setValue<string>(() => { this._extendedUpdateUser = value; }, value, 'updateUser');
    }

    private _extendedUpdateDate: Date;

    @Expose()
    @DateDecorator({ displayNameKey: 'std_OCCAuditDeactivableModel_UpdateDate' })
    @Transform(DateTimeOffset.transform)
    override get updateDate(): Date {
        return this.getValue<Date>(() => this._extendedUpdateDate, 'updateDate');
    }
    override set updateDate(value: Date) {
        this.setValue<Date>(() => { this._extendedUpdateDate = value; }, value, 'updateDate');
    }

    private _updateUserCode: number;

    @Expose()
    @StringDecorator({ displayNameKey: 'std_SnapShotFrame_UpdateUserCode' })
    get updateUserCode(): number {
        return this.getValue<number>(() => this._updateUserCode, 'updateUserCode');
    }
    set updateUserCode(value: number) {
        this.setValue<number>(() => { this._updateUserCode = value; }, value, 'updateUserCode');
    }

    private _extendedCreationUser: string;

    @Expose()
    @StringDecorator({ displayNameKey: 'std_OCCAuditDeactivableModel_CreationUser' })
    override get creationUser(): string {
        return this.getValue<string>(() => this._extendedCreationUser, 'creationUser');
    }
    override set creationUser(value: string) {
        this.setValue<string>(() => { this._extendedCreationUser = value; }, value, 'creationUser');
    }

    private _extendedCreationDate: Date;

    @Expose()
    @DateDecorator({ displayNameKey: 'std_OCCAuditDeactivableModel_CreationDate' })
    @Transform(DateTimeOffset.transform)
    override get creationDate(): Date {
        return this.getValue<Date>(() => this._extendedCreationDate, 'creationDate');
    }
    override set creationDate(value: Date) {
        this.setValue<Date>(() => { this._extendedCreationDate = value; }, value, 'creationDate');
    }

    private _creationUserCode: number;

    @Expose()
    @StringDecorator({ displayNameKey: 'std_SnapShotFrame_CreationUserCode' })
    get creationUserCode(): number {
        return this.getValue<number>(() => this._creationUserCode, 'creationUserCode');
    }
    set creationUserCode(value: number) {
        this.setValue<number>(() => { this._creationUserCode = value; }, value, 'creationUserCode');
    }

    constructor(init?: Partial<SnapShotFrame>) {
        super();
        Object.assign(this, init);
    }
}
